const validateUrl = (url) => {
    try {
        const u = new URL(url);
        return u;
    } catch (err) {
        return false;
    }
};

const ajaxCall = async (postId = '', container, actionName) => {
    if (!universityPressThemeSettings.wordpressAjaxUrl) {
        return;
    }
    const ajaxUrl = validateUrl(universityPressThemeSettings.wordpressAjaxUrl);
    if (!ajaxUrl) {
        return;
    }
    
    ajaxUrl.searchParams.set("action", actionName);
    if(postId) {
        ajaxUrl.searchParams.set("postId", postId);
    }
 
    const response = await fetch(ajaxUrl);
    if (!response.ok) {
        return;
    }

    Object.assign(container, { innerHTML: await response.text() });
};

const articleContent = async () => {
    const articleContainers = document.querySelectorAll(
        ".js-article-content"
    );

    await Promise.all([...articleContainers].map((container) => {
        if(!container.dataset.postId) {
            return;
        }

        return ajaxCall(container.dataset.postId, container, 'monthly_ajax_article_content');
    }));
};

document.addEventListener("DOMContentLoaded", () => {
    articleContent();
}); 
(function ($) {
    $(document).ready(function () {
        if( $('.article-carousel__desk').length === 0 ) return;
        $('.article-carousel__desk').slick({
            dots: false,
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            speeed: 500,
            autoplay: true,
            autoplaySpeed: 15000,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        infinite: true,
                        dots: false
                    }
                },
                {
                    breakpoint: 800,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    }
                }
            ]
        });
    });
}(jQuery));
const discountAjaxCall = async (actionName) => {
    if (!universityPressThemeSettings.wordpressAjaxUrl) {
        return;
    }
    const ajaxUrl = validateUrl(universityPressThemeSettings.wordpressAjaxUrl);
    if (!ajaxUrl) {
        return;
    }
    
    ajaxUrl.searchParams.set("action", actionName);
 
    await fetch(ajaxUrl);
};

customElements.whenDefined('foxy-customer-portal').then( async () => {
    const portals = [...document.getElementsByTagName('foxy-customer-portal')];

    portals.forEach(portal => {
        portal.addEventListener('signin', function () {
            discountAjaxCall('run_login_to_wayland_function');
        });

        portal.addEventListener('signout', function () {
            discountAjaxCall('run_login_to_wayland_function');
        });
    });
}); 
const prefix = "dl-";

const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop().split(";").shift();
  }
};

const getCustomerObject = async () => {
  const storeURL = fx_local_scripts.store_base_url;
  const customer = getCookie("foxy-session-token");

  if (!storeURL || !customer) {
    return;
  }

  try {
    const response = await fetch(
      `${storeURL}/s/customer/attributes?limit=300&name=${prefix}*&order=date_created desc`,
      {
        method: "GET",
        headers: {
          "fx.customer": customer.replace(/ /g, "+"),
        },
      }
    );

    if (!response.ok) {
      throw new Error(
        `Response error: ${response.status} ${response.statusText}`
      );
    }

    return response.json();
  } catch (error) {
    console.error("Error getting customer object", error);
  }
};

const decodeHtmlEntities = (str) => {
  return str
    .replace(/&quot;/g, '"')
    .replace(/&apos;/g, "'")
    .replace(/&amp;/g, "&")
    .replace(/&#39;/g, "'")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">");
};

const escapeQuotesInTitle = (str) => {
  // Regular expression to match and capture the "title" field with any content
  const regex = /"title":"(.*?)"[,}]/;
  // Replace double quotes within the captured title with single quotes
  return str.replace(regex, (match, p1) => {
    const fixedTitle = p1.replace(/"/g, "'").replace(/\\/g, "");
    return `"title":"${fixedTitle}",`;
  });
};
const getDownloadItems = async () => {
  const customerObject = await getCustomerObject();

  if (
    !customerObject ||
    !customerObject._embedded ||
    !customerObject._embedded["fx:attributes"]
  ) {
    return;
  }

  return customerObject._embedded["fx:attributes"]
    .filter((attribute) => attribute.name.includes(prefix))
    .map((attribute) => {
      let values = attribute.value;

      if (values.includes("&quot;")) {
        values = decodeHtmlEntities(values);
        values = escapeQuotesInTitle(values);
      }

      values = JSON.parse(values);

      if (values.download_url) {
        values.download_url = values.download_url.replace(/&amp;/g, "&");
      }

      values["date_created"] = attribute.date_created;
      return values;
    });
};

window.__monthlyReview = {
  downloadsItems: getDownloadItems,
};

const config = {
    threshold: 1
};

const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
        if( entry.intersectionRatio > 0 ) {
            entry.target.classList.add('show--el');
            observer.unobserve(entry.target);
        } else {
            entry.target.classList.remove('show--el');
        }
    })

});

window.addEventListener('load', () => {
    var el = document.querySelectorAll(".view--el");
    el.forEach(el => {
        observer.observe(el)
    });
});
(function ($) {
    $(document).ready(function () {
        var checkExist = setInterval(function () {
            if ($('.filter-option').length) {

                $('.filter-block h3').each(function (index, item) {
                    if (item.innerHTML === 'Category') {
                        $(item).parents('.filter-block').addClass('category');
                        var nextList = $(item).next();
                        nextList.find('.filter-option__sub-filter:not(.sub-filter)').parents('.filter-option').addClass('parent');
                        nextList.find('.filter-option__sub-filter.sub-filter').parents('.filter-option').addClass('child');

                        $(document).on('click', '.filter-block.category .topCat', function (e) {
                            var $this = $(this);
                            $this.toggleClass('showTop');

                            $this.nextUntil('.topCat').each(function () {
                                var topCat = $(this);
                                if (topCat.is('.parent')) {
                                    topCat.toggleClass('show');
                                    if (topCat.next().hasClass('parent')) {
                                        topCat.addClass('no-child');
                                    }
                                    if (topCat.hasClass('showChild')) {
                                        topCat.removeClass('showChild');
                                    }
                                }
                            });

                            $this.nextUntil('.topCat').each(function () {
                                var topCat = $(this);

                                if (topCat.is('.child')) {
                                    if (topCat.hasClass('show')) {
                                        topCat.removeClass('show');
                                    }
                                }
                            });
                        });
                        $(document).on('click', '.filter-block.category .parent', function (e) {
                            $(this).toggleClass('showChild');
                            $(this).nextUntil('.parent').each(function () {
                                if ($(this).is('.child')) {
                                    $(this).toggleClass('show');
                                }
                            });
                        });
                    }
                });

                clearInterval(checkExist);
            }
        }, 100); // check every 100ms
    });
}(jQuery));

window.addEventListener('load', () => {
    setInterval(myTimer, 100);
    function myTimer() {
        const filterParent = document.querySelectorAll('.filter-block.category ul li:not(.parent, .child)');

        filterParent.forEach((item, index) => {
            item.classList.add('topCat');
        });
        clearInterval(myTimer);
    }

});